import { Injectable } from '@angular/core';

import { AuthService } from "../../../shared/services/auth.service";
import { newRoute, editRoute } from "../../../shared/services/data.service";
import { despachosRoute } from "../../shared/data.service";
import { seguradorasRoute } from "./data.service";
import { segurosRoute } from "../../seguros/shared/data.service";

@Injectable()
export class SeguradoraNavigationService {

    constructor(
        private _authService: AuthService
    ) { }

    goToList() {
        var router: string = despachosRoute + '/' + segurosRoute + '/' + seguradorasRoute;
        this._authService.navigateTo(router);
    }

    goToNew() {
        var router: string = despachosRoute +  '/' + segurosRoute + '/' + seguradorasRoute + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number) {
        var router: string = despachosRoute +  '/' + segurosRoute + '/' + seguradorasRoute + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguradoras/shared/seguradora-navigation.service.ts
 **/